document.querySelectorAll('.qa button').forEach(function(b){
  b.addEventListener('click',function(){b.parentElement.classList.toggle('open');});
});
var io=new IntersectionObserver(function(entries){
  entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
},{threshold:.12});
document.querySelectorAll('section > .wrap > *').forEach(function(el){el.classList.add('reveal');io.observe(el);});
var last=0,tb=document.getElementById('topbar');
window.addEventListener('scroll',function(){
  var y=window.scrollY;
  if(y>400 && y>last){tb.style.transform='translateY(-100%)';}else{tb.style.transform='translateY(0)';}
  last=y;
});

/* ===== Launch-price countdown =====
   HONEST DEADLINE: set LAUNCH_START to the day you publish the promo.
   The timer counts down to LAUNCH_START + 7 days — the SAME fixed moment for every visitor
   (it does NOT restart per person). Keep your word: raise the price when it hits zero. */
(function(){
  var LAUNCH_START = new Date("2026-08-26T00:00:00"); // ← set to your real launch day
  var PROMO_DAYS   = 7;
  var END = new Date(LAUNCH_START.getTime() + PROMO_DAYS*24*60*60*1000);
  var box=document.getElementById('promoCountdown');
  var tbD=document.getElementById('tbD'),tbH=document.getElementById('tbH'),tbM=document.getElementById('tbM'),tbS=document.getElementById('tbS');
  var tbBox=document.getElementById('tbCount');
  if(!box && !tbBox) return;
  var timer=box?document.getElementById('cdTimer'):null;
  var dE=box?document.getElementById('cdD'):null,hE=box?document.getElementById('cdH'):null,mE=box?document.getElementById('cdM'):null,sE=box?document.getElementById('cdS'):null;
  function p(n){return (n<10?'0':'')+n;}
  function tick(){
    var diff=END-new Date();
    if(diff<=0){
      if(timer) timer.innerHTML='<span class="cd-ended">The launch price has ended.</span>';
      if(tbBox) tbBox.style.display='none';
      clearInterval(iv); return;
    }
    var s=Math.floor(diff/1000);
    var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),ss=s%60;
    if(dE){dE.textContent=p(d);hE.textContent=p(h);mE.textContent=p(m);sE.textContent=p(ss);}
    if(tbD){tbD.textContent=p(d);tbH.textContent=p(h);tbM.textContent=p(m);tbS.textContent=p(ss);}if(dE){dE.textContent=p(d);hE.textContent=p(h);mE.textContent=p(m);sE.textContent=p(ss);}
    if(tbD){tbD.textContent=p(d);tbH.textContent=p(h);tbM.textContent=p(m);tbS.textContent=p(ss);}
    var c=document.getElementById('ct2D'); if(c){c.textContent=p(d);document.getElementById('ct2H').textContent=p(h);document.getElementById('ct2M').textContent=p(m);document.getElementById('ct2S').textContent=p(ss);}
  }
  tick(); var iv=setInterval(tick,1000);
})();
/* ===== Custom video player (centered play + styled seek bar) ===== */
(function(){
  function fmt(t){t=Math.max(0,t||0);var m=Math.floor(t/60),s=Math.floor(t%60);return m+':'+(s<10?'0':'')+s;}
  document.querySelectorAll('.vid-card').forEach(function(card){
    var v=card.querySelector('video.vid-media');
    if(!v||card.dataset.vpReady) return;
    card.dataset.vpReady='1';
    var big=card.querySelector('.vid-playbtn'),
        toggle=card.querySelector('.vc-toggle'),
        bar=card.querySelector('.vc-bar'),
        fill=card.querySelector('.vc-fill'),
        buf=card.querySelector('.vc-buffer'),
        thumb=card.querySelector('.vc-thumb'),
        timeEl=card.querySelector('.vc-time'),
        mute=card.querySelector('.vc-mute');
    function tog(){ if(v.paused){v.play();} else {v.pause();} }
    v.addEventListener('play',function(){card.classList.add('playing');card.classList.remove('paused-user');});
    v.addEventListener('pause',function(){card.classList.remove('playing');card.classList.add('paused-user');});
    v.addEventListener('ended',function(){card.classList.remove('playing');v.currentTime=0;update();});
    if(big) big.addEventListener('click',tog);
    if(toggle) toggle.addEventListener('click',tog);
    v.addEventListener('click',tog);
    function update(){
      var d=v.duration||0,c=v.currentTime||0,pct=d?(c/d*100):0;
      if(fill) fill.style.width=pct+'%';
      if(thumb) thumb.style.left=pct+'%';
      if(timeEl) timeEl.textContent=fmt(c)+' / '+fmt(d);
    }
    v.addEventListener('timeupdate',update);
    v.addEventListener('loadedmetadata',update);
    v.addEventListener('progress',function(){
      try{if(v.buffered.length){var b=v.buffered.end(v.buffered.length-1),d=v.duration||1;if(buf)buf.style.width=(b/d*100)+'%';}}catch(e){}
    });
    function seekAt(x){
      if(!bar) return;
      var r=bar.getBoundingClientRect(),px=Math.min(Math.max(x-r.left,0),r.width),d=v.duration||0;
      if(d){v.currentTime=px/r.width*d;update();}
    }
    var drag=false;
    if(bar){
      bar.addEventListener('mousedown',function(e){drag=true;card.classList.add('seeking');seekAt(e.clientX);e.preventDefault();});
      window.addEventListener('mousemove',function(e){if(drag)seekAt(e.clientX);});
      window.addEventListener('mouseup',function(){if(drag){drag=false;card.classList.remove('seeking');}});
      bar.addEventListener('touchstart',function(e){drag=true;card.classList.add('seeking');seekAt(e.touches[0].clientX);},{passive:true});
      bar.addEventListener('touchmove',function(e){if(drag)seekAt(e.touches[0].clientX);},{passive:true});
      bar.addEventListener('touchend',function(){drag=false;card.classList.remove('seeking');});
    }
    if(mute){
      mute.addEventListener('click',function(){v.muted=!v.muted;card.classList.toggle('muted',v.muted);});
      card.classList.toggle('muted',v.muted);
    }
  });
})();

/* ===== Audio testimonial: live frequency waveform ===== */
(function(){
  var AC=window.AudioContext||window.webkitAudioContext;
  document.querySelectorAll('.vid-card').forEach(function(card){
    var v=card.querySelector('video.vid-media'),
        canvas=card.querySelector('.audio-wave');
    if(!v||!canvas) return;
    var g=canvas.getContext('2d');
    var actx,analyser,data,raf,dpr=Math.min(window.devicePixelRatio||1,2);
    function fit(){var w=canvas.clientWidth||260,h=canvas.clientHeight||56;canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr);}
    function bar(x,y,w,h,r){g.beginPath();if(g.roundRect){g.roundRect(x,y,w,h,r);}else{g.rect(x,y,w,h);}g.fill();}
    function ensure(){
      if(actx||!AC) return;
      try{
        actx=new AC();
        var src=actx.createMediaElementSource(v);
        analyser=actx.createAnalyser();analyser.fftSize=128;analyser.smoothingTimeConstant=.8;
        data=new Uint8Array(analyser.frequencyBinCount);
        src.connect(analyser);analyser.connect(actx.destination);
      }catch(e){analyser=null;}
    }
    function draw(){
      raf=requestAnimationFrame(draw);
      var W=canvas.width,H=canvas.height;g.clearRect(0,0,W,H);
      if(!analyser)return;
      analyser.getByteFrequencyData(data);
      var bins=data.length,bars=40,gap=Math.max(2*dpr,2),bw=(W-(bars-1)*gap)/bars;
      var grad=g.createLinearGradient(0,0,W,0);grad.addColorStop(0,'#3f7d5a');grad.addColorStop(1,'#c79155');g.fillStyle=grad;
      for(var i=0;i<bars;i++){
        var val=data[Math.floor(i/bars*bins)]/255;
        var bh=Math.max(3*dpr,val*H),x=i*(bw+gap),y=(H-bh)/2;
        bar(x,y,bw,bh,Math.min(bw/2,3*dpr));
      }
    }
    function idle(){
      cancelAnimationFrame(raf);
      var W=canvas.width,H=canvas.height;g.clearRect(0,0,W,H);
      var bars=40,gap=Math.max(2*dpr,2),bw=(W-(bars-1)*gap)/bars;g.fillStyle='rgba(255,255,255,.22)';
      for(var i=0;i<bars;i++){var bh=3*dpr,x=i*(bw+gap),y=(H-bh)/2;bar(x,y,bw,bh,bh/2);}
    }
    fit();idle();
    window.addEventListener('resize',function(){fit();if(v.paused)idle();});
    v.addEventListener('play',function(){ensure();if(actx&&actx.state==='suspended'){actx.resume();}cancelAnimationFrame(raf);draw();});
    v.addEventListener('pause',idle);
    v.addEventListener('ended',idle);
  });
})();

/* ============================================================
   SHOPIFY CART INTEGRATION
   ------------------------------------------------------------
   1) Set VARIANT_ID to your product's numeric VARIANT id
      (Shopify admin → Products → your product → click the variant;
       the URL ends in /variants/XXXXXXXXXXXXX — that number).
   2) STORE_DOMAIN:
        • Leave "" if this page is served FROM your Shopify store
          (theme / page / custom-liquid). Add-to-cart is instant (AJAX).
        • Set "your-store.myshopify.com" ONLY if this page is hosted
          OUTSIDE Shopify — buyers are sent to the store cart.
   ============================================================ */
window.SHOPIFY_CART = {
  VARIANT_ID: "58775296868677",
  STORE_DOMAIN: "",           // e.g. "luna-tucci.myshopify.com" (external hosting only)
  QUANTITY: 1,
  REDIRECT_TO_CART: false,    // true = jump to /cart after adding
  REDIRECT_TO_CHECKOUT: false // true = jump straight to checkout after adding
};
(function(){
  var C=window.SHOPIFY_CART;
  var ext=!!C.STORE_DOMAIN;
  var base=ext?('https://'+C.STORE_DOMAIN):'';
  var cartLink=document.getElementById('cartLink');
  var countEl=document.getElementById('cartCount');
  if(cartLink) cartLink.setAttribute('href', base+'/cart');

  function money(cents,cur){
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur||'USD'}).format((cents||0)/100);}
    catch(e){return '$'+((cents||0)/100).toFixed(2);}
  }
  function esc(s){return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function setCount(n){
    if(!countEl) return;
    if(n>0){countEl.textContent=n;countEl.hidden=false;}else{countEl.hidden=true;}
    if(cartLink && n>0){cartLink.classList.remove('bump');void cartLink.offsetWidth;cartLink.classList.add('bump');}
  }
  function refreshCount(){
    if(ext) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(d){if(d)setCount(d.item_count||0);}).catch(function(){});
  }

  var toast;
  function showToast(msg,href){
    if(!toast){toast=document.createElement('div');toast.className='cart-toast';document.body.appendChild(toast);}
    toast.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'+msg+(href?(' <a href="'+href+'">View cart &rarr;</a>'):'');
    toast.classList.add('show');
    clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('show');},4200);
  }

  /* ---- branded cart drawer ---- */
  var ov,dw,itemsEl,footEl,headCnt;
  function buildDrawer(){
    ov=document.createElement('div');ov.className='cart-ov';
    dw=document.createElement('div');dw.className='cart-dw';dw.setAttribute('role','dialog');dw.setAttribute('aria-label','Your cart');
    dw.innerHTML='<div class="cart-dw-head"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3h2.2l2.2 12.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.3L21.5 7H6"/></svg>Your cart <span class="cnt" id="cartHeadCnt"></span></h3><button class="cart-x" aria-label="Close cart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="cart-items" id="cartItems"></div><div class="cart-foot" id="cartFoot"></div>';
    document.body.appendChild(ov);document.body.appendChild(dw);
    itemsEl=dw.querySelector('#cartItems');footEl=dw.querySelector('#cartFoot');headCnt=dw.querySelector('#cartHeadCnt');
    ov.addEventListener('click',closeCart);
    dw.querySelector('.cart-x').addEventListener('click',closeCart);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
  }
  function openCart(){ if(ext){window.location.href=base+'/cart';return;} if(!dw)buildDrawer(); ov.classList.add('open');dw.classList.add('open');document.body.style.overflow='hidden'; loadCart(); }
  function closeCart(){ if(!dw)return; ov.classList.remove('open');dw.classList.remove('open');document.body.style.overflow=''; }
  function spinner(){ if(itemsEl)itemsEl.innerHTML='<div class="spin"></div>'; if(footEl)footEl.innerHTML=''; }
  function loadCart(){
    spinner();
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render)
      .catch(function(){itemsEl.innerHTML='<div class="cart-empty">Could not load your cart.</div>';});
  }
  function render(cart){
    setCount(cart.item_count||0);
    if(headCnt) headCnt.textContent=cart.item_count||0;
    if(!cart.items||!cart.items.length){
      itemsEl.innerHTML='<div class="cart-empty"><i class="ti"></i><svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" style="display:block;margin:0 auto 12px;opacity:.5"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3h2.2l2.2 12.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.3L21.5 7H6"/></svg>Your cart is empty.</div>';
      footEl.innerHTML='';return;
    }
    var html='';
    cart.items.forEach(function(it){
      var img=it.image||(it.featured_image&&it.featured_image.url)||'';
      html+='<div class="cart-row" data-key="'+esc(it.key)+'">'
        +(img?'<img src="'+esc(img)+'" alt="">':'')
        +'<div class="ci"><p class="ci-t">'+esc(it.product_title)+'</p>'
        +(it.variant_title&&it.variant_title!=='Default Title'?'<p class="ci-v">'+esc(it.variant_title)+'</p>':'')
        +'<div class="qty"><button data-act="dec" aria-label="Decrease quantity">&minus;</button><span>'+it.quantity+'</span><button data-act="inc" aria-label="Increase quantity">+</button></div></div>'
        +'<div class="ci-r"><span class="price">'+money(it.final_line_price,cart.currency)+'</span><button class="cart-rm" data-act="rm">Remove</button></div>'
        +'</div>';
    });
    itemsEl.innerHTML=html;
    footEl.innerHTML='<div class="cart-sub"><span class="l">Subtotal</span><span class="v">'+money(cart.total_price,cart.currency)+'</span></div>'
      +'<p class="cart-note">Taxes and shipping calculated at checkout.</p>'
      +'<button class="cart-co" id="cartCo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Checkout</button>'
      +'<a class="cart-view" href="'+base+'/cart">View full cart</a>';
    itemsEl.querySelectorAll('.cart-row').forEach(function(row){
      var key=row.getAttribute('data-key');
      row.querySelector('[data-act=inc]').addEventListener('click',function(){change(key,(+row.querySelector('.qty span').textContent)+1);});
      row.querySelector('[data-act=dec]').addEventListener('click',function(){change(key,Math.max(0,(+row.querySelector('.qty span').textContent)-1));});
      row.querySelector('[data-act=rm]').addEventListener('click',function(){change(key,0);});
    });
    footEl.querySelector('#cartCo').addEventListener('click',function(){window.location.href=base+'/checkout';});
  }
  function change(key,q){
    spinner();
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json();}).then(render).catch(function(){loadCart();});
  }

  function addToCart(btn){
    var id=C.VARIANT_ID;
    if(!id||id==="REPLACE_WITH_VARIANT_ID"){
      alert("Set your Shopify VARIANT_ID in the SHOPIFY_CART config (top of this script) to enable add-to-cart.");
      return;
    }
    if(ext){
      window.location.href = base+'/cart/'+id+':'+C.QUANTITY + (C.REDIRECT_TO_CHECKOUT?'?checkout':'');
      return;
    }
    if(btn) btn.classList.add('is-loading');
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:C.QUANTITY}]})
    }).then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
      .then(function(res){
        if(btn) btn.classList.remove('is-loading');
        if(!res.ok){showToast((res.d&&res.d.description)||'Could not add to cart.');return;}
        if(C.REDIRECT_TO_CHECKOUT){window.location.href='/checkout';return;}
        if(C.REDIRECT_TO_CART){window.location.href='/cart';return;}
        openCart();
      }).catch(function(){
        if(btn) btn.classList.remove('is-loading');
        showToast('Could not add to cart. Please try again.');
      });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function(el){
    el.addEventListener('click',function(e){e.preventDefault();addToCart(el);});
  });
  if(cartLink){ cartLink.addEventListener('click',function(e){ if(ext) return; e.preventDefault(); openCart(); }); }
  window.LunaCart={open:openCart,close:closeCart};
  refreshCount();
})();